import React from 'react'
import {connect} from 'react-redux'
import {Link,withRouter} from 'react-router-dom'
import DataLoader from '../data/DataLoader'
import HeroCarousel from '../hero/HeroCarousel'
import Footer from '../footer/Footer'

class FilmsPage extends React.Component {


  constructor(){
    super();

    this.getTumbNail = this.getTumbNail.bind(this)
  }

  getTumbNail(item={},i){


      // let placeHolder = this.props.filmData.data[0]

        //item  = placeHolder

        if(!item.acf.poster_image){
          return null
        }

        let imageStyle={
            backgroundImage:'url('+item.acf.poster_image.sizes.medium_large+')'
        }


        return(
            <Link key={'film'+i} className="film-thumb" to={'/project/'+item.slug}>
              <div className="imageHolder">
                <div className="image" style={imageStyle}></div>
              </div>
              <div className="title">
                <h2><span dangerouslySetInnerHTML={{__html:item.title.rendered}}></span>


                      {
                        (item.acf.director)?
                          <span className="director mobile-hide"><em>Director </em><span dangerouslySetInnerHTML={{__html:item.acf.director}} ></span></span>
                        : null
                      }
                </h2>

                    {
                      (item.acf.director)?
                          <div className="mobile-only director"><em>Director </em><span dangerouslySetInnerHTML={{__html:item.acf.director}} ></span></div>
                    : null
                  }


              </div>
            </Link>
        )
  }



  render () {



      let carouselSlides = []



      if(this.props.filmData){

          let slidesToLoad = (this.props.filmData.data.length < 5)? this.props.filmData.data.length : 5
          for(let i = 0 ;i < slidesToLoad ; i++ ){

              let slide = this.props.filmData.data[i]
              carouselSlides.push({
                        title : slide.title.rendered,
                        image : slide.acf.poster_image.url,
                        slug : slide.slug
                  })
          }
      }


      return(
        <DataLoader load="films">
        <div className="page-wrapper film-page">

        <HeroCarousel slides={carouselSlides}></HeroCarousel>

        <section className="film-list">
              {
                  (this.props.filmData)?
                    this.props.filmData.data.map((item,i) => {
                      return this.getTumbNail(item,i)
                    })
                  :null
              }


        </section>

        <Footer></Footer>
        </div>

        </DataLoader>
      )
  }
}

const mapStateToProps = (state) => {
    const filmData = state.filmData

    return{
      filmData
    }
}

export default withRouter(connect(mapStateToProps,null)(FilmsPage))



// WEBPACK FOOTER //
// ./src/modules/pages/FilmsPage.js